"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcLocationBuilder = void 0;
var bc_location_builder_constants_1 = require("./bc-location-builder-constants");
var bc_location_builder_constants_2 = require("./bc-location-builder-constants");
var bc_location_builder_constants_3 = require("./bc-location-builder-constants");
var bc_location_builder_constants_4 = require("./bc-location-builder-constants");
var bc_location_builder_constants_5 = require("./bc-location-builder-constants");
var BcLocationBuilder = (function () {
    function BcLocationBuilder() {
    }
    BcLocationBuilder.prototype.getPosition = function (targetOffset, coachOffset, viewportOffset) {
        var jsonObject = { x: 0, y: 0 };
        var permut = this.permute(this.center, this.start, this.end);
        for (var _i = 0, permut_1 = permut; _i < permut_1.length; _i++) {
            var iterator = permut_1[_i];
            var yPosition = this.getXYPosition(targetOffset, coachOffset, viewportOffset, { axis: bc_location_builder_constants_5.BC_LOCATION_BUILDER_Y, sizeProperty: bc_location_builder_constants_3.BC_LOCATION_BUILDER_HEIGHT }, iterator);
            if (yPosition.kind === 'start') {
                var xPosition = this.getXYPosition(targetOffset, coachOffset, viewportOffset, { axis: bc_location_builder_constants_5.BC_LOCATION_BUILDER_X, sizeProperty: bc_location_builder_constants_5.BC_LOCATION_BUILDER_WIDTH }, iterator);
                var dependentYPosition = this.getXYPosition(targetOffset, coachOffset, viewportOffset, { axis: bc_location_builder_constants_5.BC_LOCATION_BUILDER_Y, sizeProperty: bc_location_builder_constants_3.BC_LOCATION_BUILDER_HEIGHT }, iterator, xPosition);
                if (xPosition.value != null && dependentYPosition.value != null) {
                    jsonObject = { x: xPosition.value, y: dependentYPosition.value };
                    this.validateXPosition(xPosition, dependentYPosition);
                }
            }
            else {
                var dependentXPosition = this.getXYPosition(targetOffset, coachOffset, viewportOffset, { axis: bc_location_builder_constants_5.BC_LOCATION_BUILDER_X, sizeProperty: bc_location_builder_constants_5.BC_LOCATION_BUILDER_WIDTH }, iterator, yPosition);
                if (dependentXPosition.value != null && yPosition.value != null) {
                    jsonObject = { x: dependentXPosition.value, y: yPosition.value };
                    this.validateYPosition(dependentXPosition, yPosition);
                    dependentXPosition.kind = bc_location_builder_constants_2.BC_LOCATION_BUILDER_CENTER_POSITION;
                    if (dependentXPosition.kind === bc_location_builder_constants_2.BC_LOCATION_BUILDER_CENTER_POSITION) {
                        return jsonObject;
                    }
                }
            }
        }
        return jsonObject;
    };
    BcLocationBuilder.prototype.validateXPosition = function (xPosition, yPosition) {
        if (xPosition.kind == bc_location_builder_constants_2.BC_LOCATION_BUILDER_END_POSITION) {
            this.position = "".concat(bc_location_builder_constants_4.BC_LOCATION_BUILDER__RIGHT);
        }
        else if (xPosition.kind == bc_location_builder_constants_4.BC_LOCATION_BUILDER_START_POSITION) {
            this.position = "".concat(bc_location_builder_constants_3.BC_LOCATION_BUILDER_LEFT);
        }
        else if (xPosition.kind == bc_location_builder_constants_2.BC_LOCATION_BUILDER_CENTER_POSITION && yPosition.kind == bc_location_builder_constants_2.BC_LOCATION_BUILDER_END_POSITION) {
            this.position = "".concat(bc_location_builder_constants_1.BC_LOCATION_BUILDER_BOTTOM);
        }
        else if (xPosition.kind == bc_location_builder_constants_2.BC_LOCATION_BUILDER_CENTER_POSITION && yPosition.kind == bc_location_builder_constants_4.BC_LOCATION_BUILDER_START_POSITION) {
            this.position = "".concat(bc_location_builder_constants_4.BC_LOCATION_BUILDER_TOP);
        }
    };
    BcLocationBuilder.prototype.validateYPosition = function (xPosition, yPosition) {
        if (yPosition.kind == bc_location_builder_constants_2.BC_LOCATION_BUILDER_END_POSITION) {
            this.position = "".concat(bc_location_builder_constants_1.BC_LOCATION_BUILDER_BOTTOM);
        }
        else if (yPosition.kind == bc_location_builder_constants_4.BC_LOCATION_BUILDER_START_POSITION) {
            this.position = "".concat(bc_location_builder_constants_4.BC_LOCATION_BUILDER_TOP);
        }
        else if (yPosition.kind == bc_location_builder_constants_2.BC_LOCATION_BUILDER_CENTER_POSITION && xPosition.kind == bc_location_builder_constants_2.BC_LOCATION_BUILDER_END_POSITION) {
            this.position = "".concat(bc_location_builder_constants_4.BC_LOCATION_BUILDER__RIGHT);
        }
        else if (yPosition.kind == bc_location_builder_constants_2.BC_LOCATION_BUILDER_CENTER_POSITION && xPosition.kind == bc_location_builder_constants_4.BC_LOCATION_BUILDER_START_POSITION) {
            this.position = "".concat(bc_location_builder_constants_3.BC_LOCATION_BUILDER_LEFT);
        }
    };
    BcLocationBuilder.prototype.permute = function (center, start, end) {
        var functions = [center, start, end];
        var response = [];
        for (var _i = 0, functions_1 = functions; _i < functions_1.length; _i++) {
            var func1 = functions_1[_i];
            for (var _a = 0, functions_2 = functions; _a < functions_2.length; _a++) {
                var func2 = functions_2[_a];
                for (var _b = 0, functions_3 = functions; _b < functions_3.length; _b++) {
                    var func3 = functions_3[_b];
                    if (func1 != func2 && func2 != func3 && func1 != func3) {
                        response.push([
                            func1, func2, func3
                        ]);
                    }
                }
            }
        }
        return response;
    };
    BcLocationBuilder.prototype.center = function (targetOffset, coachOffset, viewportOffset, axisConfig, mainAlignment) {
        var centerTarget = targetOffset[axisConfig.axis] + targetOffset[axisConfig.sizeProperty] / bc_location_builder_constants_3.BC_LOCATION_BUILDER_NUMBER_2;
        var halfSizePropertyCoach = coachOffset[axisConfig.sizeProperty] / bc_location_builder_constants_3.BC_LOCATION_BUILDER_NUMBER_2;
        var positionFinalYCoach = centerTarget + halfSizePropertyCoach;
        var altoViewport = viewportOffset[axisConfig.sizeProperty];
        var initialPositionCoach = centerTarget - halfSizePropertyCoach;
        var isAvailableCenterStart = initialPositionCoach > 0;
        var isAvailableCenterEnd = centerTarget + halfSizePropertyCoach <= viewportOffset[axisConfig.sizeProperty];
        var isAvailableCenter = isAvailableCenterStart && isAvailableCenterEnd;
        var spaceToStart = targetOffset[axisConfig.axis];
        var overflowCoach = Math.abs(altoViewport - positionFinalYCoach);
        var spaceToEnd = Math.abs(altoViewport - positionFinalYCoach);
        var response = { kind: bc_location_builder_constants_2.BC_LOCATION_BUILDER_CENTER_POSITION, value: null };
        if (!mainAlignment) {
            if (isAvailableCenter) {
                response.value = centerTarget - halfSizePropertyCoach;
            }
            else {
                if (!isAvailableCenterStart) {
                    this.validateScroll(initialPositionCoach, spaceToEnd, halfSizePropertyCoach, axisConfig, response);
                }
                else {
                    this.validateAvailableCenterStart(overflowCoach, spaceToStart, halfSizePropertyCoach, response, viewportOffset, axisConfig);
                }
            }
        }
        else {
            if (mainAlignment.kind != bc_location_builder_constants_2.BC_LOCATION_BUILDER_CENTER_POSITION) {
                this.validateCenterNotMain(response, isAvailableCenterStart, coachOffset, axisConfig, initialPositionCoach, targetOffset, viewportOffset);
            }
        }
        return response;
    };
    BcLocationBuilder.prototype.start = function (targetOffset, coachOffset, viewportOffset, axisConfig, mainAlignment) {
        var spaceToStart = targetOffset[axisConfig.axis];
        var arrowSpace = bc_location_builder_constants_1.BC_LOCATION_BUILDER_ARROW_SPACE;
        var response = {
            kind: bc_location_builder_constants_4.BC_LOCATION_BUILDER_START_POSITION,
            value: null,
        };
        var isAvailableStart = spaceToStart - arrowSpace >= coachOffset[axisConfig.sizeProperty];
        if (!mainAlignment) {
            if (isAvailableStart) {
                response.value = targetOffset[axisConfig.axis] - arrowSpace - coachOffset[axisConfig.sizeProperty];
            }
        }
        else {
            var space = 0;
            if (mainAlignment.kind == bc_location_builder_constants_2.BC_LOCATION_BUILDER_CENTER_POSITION) {
                space = targetOffset[axisConfig.sizeProperty] + arrowSpace;
            }
            var finalPositionTarget = targetOffset[axisConfig.axis] + targetOffset[axisConfig.sizeProperty];
            isAvailableStart = finalPositionTarget - coachOffset[axisConfig.sizeProperty] - space >= 0;
            if (isAvailableStart) {
                response.value = finalPositionTarget - coachOffset[axisConfig.sizeProperty] - space;
            }
        }
        return response;
    };
    BcLocationBuilder.prototype.end = function (targetOffset, coachOffset, viewportOffset, axisConfig, mainAlignment) {
        var arrowSpace = bc_location_builder_constants_1.BC_LOCATION_BUILDER_ARROW_SPACE;
        var response = {
            kind: bc_location_builder_constants_2.BC_LOCATION_BUILDER_END_POSITION,
            value: null,
        };
        var spaceToEnd = viewportOffset[axisConfig.sizeProperty] - targetOffset[axisConfig.axis] - targetOffset[axisConfig.sizeProperty];
        var isAvailableEnd = spaceToEnd - arrowSpace >= coachOffset[axisConfig.sizeProperty];
        if (!mainAlignment) {
            if (isAvailableEnd) {
                response.value = targetOffset[axisConfig.axis] + arrowSpace + targetOffset[axisConfig.sizeProperty];
            }
        }
        else {
            var space = 0;
            if (mainAlignment.kind == bc_location_builder_constants_2.BC_LOCATION_BUILDER_CENTER_POSITION) {
                space = targetOffset[axisConfig.sizeProperty] + arrowSpace;
            }
            var finalPositionCoach = targetOffset[axisConfig.axis] + coachOffset[axisConfig.sizeProperty] + space;
            isAvailableEnd = finalPositionCoach <= viewportOffset[axisConfig.sizeProperty];
            if (isAvailableEnd) {
                response.value = targetOffset[axisConfig.axis] + space;
            }
        }
        return response;
    };
    BcLocationBuilder.prototype.getXYPosition = function (targetOffset, coachOffset, viewportOffset, axisConfig, permutation, mainAlignment, arrowOffset) {
        var response = {
            kind: bc_location_builder_constants_2.BC_LOCATION_BUILDER_END_POSITION,
            value: null,
        };
        for (var _i = 0, permutation_1 = permutation; _i < permutation_1.length; _i++) {
            var func = permutation_1[_i];
            response = func.call(this, targetOffset, coachOffset, viewportOffset, axisConfig, mainAlignment, arrowOffset);
            if (response.value != null) {
                return response;
            }
        }
        return response;
    };
    BcLocationBuilder.prototype.validateCenterNotMain = function (response, isAvailableCenterStart, coachOffset, axisConfig, initialPositionCoach, targetOffset, viewportOffset) {
        var centerTarget = targetOffset[axisConfig.axis] + targetOffset[axisConfig.sizeProperty] / bc_location_builder_constants_3.BC_LOCATION_BUILDER_NUMBER_2;
        var halfSizePropertyCoach = coachOffset[axisConfig.sizeProperty] / bc_location_builder_constants_3.BC_LOCATION_BUILDER_NUMBER_2;
        var isAvailableCenterEnd = centerTarget + halfSizePropertyCoach <= viewportOffset[axisConfig.sizeProperty];
        var isAvailableCenter = isAvailableCenterStart && isAvailableCenterEnd;
        var spaceToStart = targetOffset[axisConfig.axis];
        var positionFinalYCoach = centerTarget + halfSizePropertyCoach;
        var overflowCoach = Math.abs(viewportOffset[axisConfig.sizeProperty] - positionFinalYCoach);
        if (isAvailableCenter) {
            response.value = centerTarget - halfSizePropertyCoach;
        }
        else {
            if (!isAvailableCenterStart) {
                this.validateOverflowCoach(overflowCoach, coachOffset, axisConfig, initialPositionCoach, response);
            }
            else {
                if (overflowCoach <= coachOffset[axisConfig.sizeProperty] && overflowCoach <= spaceToStart) {
                    response.value = viewportOffset[axisConfig.sizeProperty] - coachOffset[axisConfig.sizeProperty];
                }
            }
        }
    };
    BcLocationBuilder.prototype.validateAvailableCenterStart = function (overflowCoach, spaceToStart, halfSizePropertyCoach, response, viewportOffset, axisConfig) {
        if (overflowCoach <= spaceToStart && halfSizePropertyCoach >= overflowCoach &&
            spaceToStart < halfSizePropertyCoach) {
            response.value = viewportOffset[axisConfig.sizeProperty];
        }
    };
    BcLocationBuilder.prototype.validateOverflowCoach = function (overflowCoach, coachOffset, axisConfig, initialPositionCoach, response) {
        if (overflowCoach <= coachOffset[axisConfig.sizeProperty] && overflowCoach >= Math.abs(initialPositionCoach)) {
            response.value = 0;
        }
    };
    BcLocationBuilder.prototype.validateScroll = function (initialPositionCoach, spaceToEnd, halfSizePropertyCoach, axisConfig, response) {
        if (Math.abs(initialPositionCoach) <= spaceToEnd && halfSizePropertyCoach >=
            Math.abs(initialPositionCoach) && spaceToEnd < halfSizePropertyCoach) {
            if (axisConfig.axis == bc_location_builder_constants_5.BC_LOCATION_BUILDER_X) {
                response.value = window.scrollX;
            }
            else {
                response.value = window.scrollY;
            }
        }
    };
    return BcLocationBuilder;
}());
exports.BcLocationBuilder = BcLocationBuilder;
